import React from 'react';
import PropTypes from 'prop-types';
import {Bar} from 'react-chartjs-2';
import clsx from 'clsx';
import {makeStyles, useTheme} from '@material-ui/styles';
import {
    Card,
    CardHeader,
    CardContent,
    Divider
} from '@material-ui/core';
import data from './data';

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%'
    },
    chartContainer: {
        position: 'relative'
    },
    stats: {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'center'
    }
}));

const BarChart = props => {
    const {className, ...rest} = props;
    const classes = useStyles(props);
    const theme = useTheme();
    const {items, labels} = data;

    const getChartData = () => {
        const chartData = {
            datasets: []
        };

        chartData.datasets = items.map((item) => {
            return {
                label: item.label,
                type: 'line',
                data: item.data,
                lineTension: 0.1,
                borderColor: theme.palette[item.palette].main,
                backgroundColor: theme.palette[item.palette].main,

                pointBorderColor: theme.palette[item.palette].dark,
                pointBackgroundColor: theme.palette[item.palette].dark,

                pointHoverBackgroundColor: theme.palette[item.palette].dark,
                pointHoverBorderColor: theme.palette[item.palette].dark,

                pointRadius: 5,
                pointStyle: item.pointStyle
            }
        });

        const chartOptions = {
            responsive: true,
            tooltips: {
                mode: 'nearest'
            },
            legend: {
                labels: {
                    usePointStyle: true,
                },
            },
            elements: {
                line: {
                    fill: false
                }
            },
            scales: {
                xAxes: [
                    {
                        display: true,
                        gridLines: {
                            display: true
                        },
                        labels: labels
                    }
                ],
                yAxes: [
                    {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        gridLines: {
                            display: true
                        },
                        labels: {
                            show: true
                        },
                        ticks: {
                            beginAtZero: true
                        }
                    }
                ]
            }
        };

        return {
            data: chartData,
            options: chartOptions
        };
    };

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardHeader
                title="Monthly Promotion Frequency"
            />
            <Divider/>
            {items && labels && (
                <CardContent>
                    <div className={classes.chartContainer}>
                        <Bar {...getChartData()}/>
                    </div>
                </CardContent>
            )}
        </Card>
    );
};

BarChart.propTypes = {
    className: PropTypes.string
};

export default BarChart;
